import { Paragraph, Title } from "@/components/ui/typography";
import Image from "next/image";
import bg from "@/public/Graphics.png";
import { format } from "date-fns";

export default function Header({ data }) {

  return (
     <div className=" h-[220px] md:h-[209px] lg:h-[342px] bg-midnightIndigo-100 w-screen sticky flex justify-center items-center  ml-[-50vw] mr-[-50vw] left-0 right-0 overflow-hidden">
      <div className=" absolute mr-auto  w-full ">
        <div className="mx-auto max-w-[1440px] px-3 md:px-6  lg:px-11 flex flex-col items-center">
          <Title
            size="xxl"
            className="mb-4 leading-[45px] text-[32px] text-center"
          >
           Privacy Policy
          </Title>

          <Paragraph className="text-midnightIndigo-300 ">
            Last Updated {data?.updatedOn && format(new Date(data.updatedOn), "dd/MM/yyyy")}
          </Paragraph>
        </div>
      </div>

      <Image
        src={`${bg.src}`}
        className="absolute bottom-[0px] left-0 !h-full lg:w-full"
        width={1}
        height={1}
        layout="responsive"
      />
    </div>
  );
}
